import { useAppDispatch, useAppSelector } from "../../../store/hooks/app-store.hook";
import { Session } from "../model";
import { LoginRequest } from "../model/login-request";
import { logIn, logOut, selectIsLoading, selectSession, selectError } from "../store/auth.slice";

export const useAuth = (): {
  session: Session;
  submitLoginRequest: (request: LoginRequest) => void;
  logOut: () => void;
  selectIsLoading?: boolean;
  error: string | null;
} => {
  const session = useAppSelector(selectSession);
  const isLoading = useAppSelector(selectIsLoading);
  const error = useAppSelector(selectError);

  const dispatch = useAppDispatch();
  return {
    session,
    submitLoginRequest: (request: LoginRequest) => {
      void dispatch(logIn(request));
    },
    logOut: () => {
      dispatch(logOut());
    },
    selectIsLoading: isLoading,
    error,
  };
};